import React, { useState, useEffect } from 'react';
import CarCard from '../components/CarCard';
import BookingModal from '../components/BookingModal';

const CATEGORIES = ['All', 'Economic', '4x4', 'Van', 'Sedan'];

export default function Cars() {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('All');
  const [onlyAvailable, setOnlyAvailable] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);

  const fetchCars = () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (category !== 'All') params.append('category', category);
    if (onlyAvailable) params.append('available', 'true');
    fetch(`/api/cars?${params}`)
      .then(r => r.json())
      .then(data => { setCars(data); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { fetchCars(); }, [search, category, onlyAvailable]);

  return (
    <>
      <section className="search-section">
        <div className="container">
          <div className="search-bar">
            <div className="search-input-wrap">
              <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
              <input
                className="search-input"
                placeholder="Search by name…"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
            <select className="search-select" value={category} onChange={e => setCategory(e.target.value)}>
              {CATEGORIES.map(c => <option key={c}>{c}</option>)}
            </select>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-muted)', fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap' }}>
              <input
                type="checkbox"
                checked={onlyAvailable}
                onChange={e => setOnlyAvailable(e.target.checked)}
                style={{ accentColor: 'var(--red)', width: 16, height: 16 }}
              />
              Available only
            </label>
          </div>
        </div>
      </section>

      <section className="cars-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">OUR <span>FLEET</span></h2>
            <span className="section-count">{cars.length} vehicle{cars.length !== 1 ? 's' : ''} found</span>
          </div>

          {/* Category Pills */}
          <div style={{ display: 'flex', gap: 8, marginBottom: 32, flexWrap: 'wrap' }}>
            {CATEGORIES.map(c => (
              <button
                key={c}
                onClick={() => setCategory(c)}
                style={{
                  padding: '7px 18px',
                  borderRadius: 20,
                  fontSize: 13,
                  fontWeight: 500,
                  border: '1px solid',
                  transition: 'var(--transition)',
                  cursor: 'pointer',
                  background: category === c ? 'var(--red)' : 'transparent',
                  borderColor: category === c ? 'var(--red)' : 'var(--border)',
                  color: category === c ? 'white' : 'var(--text-muted)',
                  fontFamily: 'var(--font-body)',
                }}
              >{c}</button>
            ))}
          </div>

          {loading ? (
            <div className="loading">
              <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} style={{ animation: 'spin 1s linear infinite' }}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
              </svg>
              <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
            </div>
          ) : cars.length === 0 ? (
            <div className="empty-state">
              <svg width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}><path strokeLinecap="round" strokeLinejoin="round" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
              <div style={{ marginTop: 12 }}>No vehicles found matching your search.</div>
            </div>
          ) : (
            <div className="cars-grid">
              {cars.map(car => (
                <CarCard key={car.id} car={car} onBook={setSelectedCar} />
              ))}
            </div>
          )}
        </div>
      </section>

      {selectedCar && (
        <BookingModal
          car={selectedCar}
          onClose={() => setSelectedCar(null)}
          onSuccess={() => { setSelectedCar(null); fetchCars(); }}
        />
      )}
    </>
  );
}